module.exports = __webpack_public_path__ + "img/new_banner_en.63343d27.jpg";